import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {input} from "../../../utils/linker";
import {ComponentContext} from "../../../contexts";
import generateUid from "../../../utils/generateUid";

function LinksUploader(props) {
  const store = useLocalObservable(() => ({
    links:"",
  }));
  const compStore=useContext(ComponentContext);
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const checkHttpUrl=(string)=> {
    let givenURL;
    try {
      givenURL = new URL(string);
    } catch (error) {
      return false;
    }
    return givenURL.protocol === "http:" || givenURL.protocol === "https:";
  };
  const onKeyUp=(e)=>{
    if(e.which === 27) {
      props.onClose();
    }
    if( (!props.single && (e.ctrlKey || e.metaKey) && e.which === 13) || (props.single && e.which === 13) ) {
      e.preventDefault();
      e.stopPropagation();
      const links=store.links.split(/\r?\n/);
      const validUrl=[];
      for(let i in links) {
        if(checkHttpUrl(links[i])) {
          validUrl.push(links[i]);
        }
      }
      let needScroll=false;
      if(validUrl.length) {
        if(props.replace) {
          compStore.replaceCurFile(validUrl[0]);
        } else {
          runInAction(() => {
            for (let i in validUrl) {
              compStore.data.push({
                sys_uid: generateUid(),
                uploading: true,
                uploading_url: validUrl[i]
              });
            }
            compStore.uploadNext();
            needScroll=true;
          });
        }
      }
      props.onClose(needScroll);
    }
  };

  return (
    <div>
      {props.single?(
        <input type="text" autoFocus={true} onKeyDown={(e)=>{ onKeyUp(e); }} {...input(store, "links")} style={{width: 300}} placeholder={"Вставьте ссылки на фотографии и нажмите Enter."} />
      ):(
        <textarea autoFocus={true} onKeyDown={(e)=>{ onKeyUp(e); }} {...input(store, "links")} style={{height:120, width: 300, fontSize:12}} placeholder={"Вставьте ссылки на изображения и нажмите Ctrl+Enter. При множественной вставке каждая ссылка должна быть вставлена отдельной строкой."} />
      )}
    </div>
  )
};

LinksUploader.defaultProps = {};

LinksUploader.propTypes = {}

export default observer(LinksUploader);
